import { findMessage } from '@bimser/components';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { Mobile } from '../../..';
import { INotificationMessage } from '../entities';
import { showPopupMessage, showToasterMessage } from './';

export function showServerSideMessages(
	data: LayoutCreatorEntities.INormalizedLayoutItems,
	windowId?: string,
	validate: boolean = true
): LayoutCreatorEntities.INormalizedLayoutItems {
	if (data?.result?.length) {
		const formItemId = data.result[0];
		const items = data.entities.items;
		const formItem = items[formItemId];

		if (formItem?.properties?.messages) {
			const messages: INotificationMessage[] = formItem.properties.messages;
			const notificationMessages: INotificationMessage[] = messages.filter(
				i => i.alertType !== 'Validation'
			);
			const validationMessages: INotificationMessage[] = messages.filter(
				i => i.alertType === 'Validation'
			);

			showNotificationMessages(notificationMessages);
			validate && showValidationMessages(validationMessages, windowId);

			notificationMessages.length &&
				Mobile.MobileView.mobileServerSideMessages(
					'notificationMessages',
					notificationMessages
				);
			validationMessages.length &&
				Mobile.MobileView.mobileServerSideMessages(
					'validationMessages',
					validationMessages
				);

			// Remove messages
			data.entities.items[formItemId].properties.messages = [];
		}
	}

	return data;
}

function getTitleByAlertType(alertType: RuleEngineEntities.AlertType | 'Validation') {
	switch (alertType) {
		case 'Error':
			return findMessage.get('100926');
		case 'Info':
			return findMessage.get('100647');
		case 'Success':
			return findMessage.get('101879');
		default:
			return findMessage.get('100652');
	}
}

function showNotificationMessages(notificationMessages: INotificationMessage[]) {
	// Show notification messages one by one
	notificationMessages.forEach(message => {
		const { title, alertType, text } = message;
		const calculatedTitle = title || getTitleByAlertType(alertType);
		switch (message.dialogType) {
			case 'Toaster': {
				showToasterMessage(calculatedTitle, alertType, text);
				break;
			}
			case 'Popup': {
				showPopupMessage(calculatedTitle, alertType, text);
				break;
			}
			case 'Summary': {
				break;
			}
			default:
				console.warn('The notification type that you trying to run is not found!');
		}
	});
}

function showValidationMessages(validationMessages: INotificationMessage[], windowId: string) {
	// Show validation messages on signle notification
	const popupMessages: INotificationMessage[] = validationMessages.filter(
		i => i.dialogType === 'Popup'
	);
	const toasterMessages: INotificationMessage[] = validationMessages.filter(
		i => i.dialogType === 'Toaster'
	);

	if (toasterMessages?.length) {
		let highlightList: string[] = [];

		toasterMessages.forEach(message => {
			highlightList = [...highlightList, ...(message?.highlightList || [])];
		});

		highlightList = highlightList.filter((value, index, self) => self.indexOf(value) === index);

		toasterMessages.forEach(m => {
			showToasterMessage(m?.title, 'Validation', m?.text, highlightList, windowId);
		});
	}

	if (popupMessages?.length) {
		let highlightList: string[] = [];

		popupMessages.forEach(message => {
			highlightList = [...highlightList, ...(message?.highlightList || [])];
		});

		highlightList = highlightList?.filter(
			(value, index, self) => self.indexOf(value) === index
		);

		popupMessages.forEach(m => {
			showPopupMessage(m?.title, 'Validation', m?.text, highlightList, windowId);
		});
	}
}
